import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { UtilsService } from '../../http-services/services/utils.service';
import { QfaEventType } from '../enums/event-type.enum';
import { LoggingService } from './logging.service';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const httpInterceptorFn: HttpInterceptorFn = (req, next) => {
  const loggingService = inject(LoggingService);
  const utilsService = inject(UtilsService);

  // Only for our project api calls, not auth endpoints
  if (req.url.includes('/policy') || req.url.includes('/userinfo')) {
    let token = utilsService.getBearerToken();

    if (token != null) {
      const defaultHeaders: { [key: string]: string } = {
        'Content-Type': 'application/json',
        ApiVersion: '1',
        RequestId: utilsService.getRequestId(),
        RequestDate: utilsService.getCurrentDate(),
        Authorization: `Bearer ${token}`,
      };

      const clonedRequest = req.clone({
        setHeaders: defaultHeaders,
      });

      const withoutParams = req.url.split('?')[0];
      const segments = withoutParams.split('/').filter(segment => segment.length > 0);
      const endpoint = `/${segments[segments.length - 1]}`;

      return next(clonedRequest).pipe(
        catchError(error => {
          // Handle errors globally
          console.error(`HTTP error occurred at ${endpoint}: `, error.message);
          loggingService.logError(error);
          throw error;
        }),
      );
    }
    loggingService.logEvent(QfaEventType.WARNING, 'sf_access_token is missing in sessionStorage');
  }
  return next(req);
};
